export const ReceivedProductsColumns = {
  ACCEPT: 'accept',
  REJECT: 'reject',
  SKU: 'sku',
  INVENTORY_LOCATION_ID: 'inventoryLocationId',
  LOT: 'lot',
  EXPIRATION_DATE: 'expirationDate',
  TOTAL: 'total',
} as const;
